export default __webpack_public_path__ + "static/media/subbase.5c5d2c6c.png";